import {
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- Read http://go/cfe-no-import-apollo-functions
	useQuery,
} from 'react-apollo';
import gql from 'graphql-tag';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { expValEquals } from '@confluence/feature-experiments';

import { useIsEstablishedUserTraitName } from '../useIsEstablishedUserTraitName.ts';
import { useExperimentalUserPersonalizationQuery } from '../useExperimentalUserPersonalizationQuery.ts';
import type {
	PersonalizationQuery as PersonalizationQueryData,
	PersonalizationQueryVariables,
} from '../useOnboardingEligible/__types__/UserPersonalizationQuery.ts';

const UseIsEstablishedUserUserPersonalizationQuery =
	// eslint-disable-next-line graphql-relay-compat/no-experimental-directives -- Read http://go/cfe-no-experimental-directives
	gql`
		query useIsEstablishedUserUserPersonalizationQuery($userId: String!) @experimental {
			experimentalUserPersonalization(userId: $userId) {
				attributes {
					name
					value
				}
			}
		}
	`;

export const useIsEstablishedUser = ({ skip }: { skip: boolean }) => {
	const { userId } = useSessionData();
	const isEstablishedUserTraitName = useIsEstablishedUserTraitName();

	const userPersonalizationQueryArgs = {
		skip: skip || !userId,
		variables: { userId: userId ?? '' },
	};

	// eslint-disable-next-line graphql-client-usage/graphql-generic-types
	const { data, loading, error } = expValEquals(
		'confluence_deprecate_experimental_personalization',
		'isEnabled',
		true,
	)
		? // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
			useExperimentalUserPersonalizationQuery(userPersonalizationQueryArgs)
		: // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
			useQuery<PersonalizationQueryData, PersonalizationQueryVariables>(
				UseIsEstablishedUserUserPersonalizationQuery,
				userPersonalizationQueryArgs,
			);

	const isEstablishedUser = Boolean(
		data?.experimentalUserPersonalization?.attributes?.some(
			({ name, value }: { name: string; value: string }) =>
				name === isEstablishedUserTraitName && value === 'true',
		),
	);
	return { isEstablishedUser, loading, error };
};
